import React from 'react';
import isNil from 'lodash.isnil';
import PropTypes from 'prop-types';
import { NA } from '../../../../../constants/shared/CommonConstants';
import {
    getRetellTitle,
    getOralComprehensionValue,
    getWrittenComprehensionValue,
} from '../../../../../utils/shared/trcUtils';
import Accuracy from './Accuracy';
import MsvGraph from './MsvGraph';
import SideBlock from './SideBlock';

const TrcStatusSection = ({ result, showMsvGraph }) => {
    const { trcScore, probeDetailResult } = result;
    const {
        accuracy,
        atlas,
        bookType,
        measure,
        selfCorrectionsRate,
        errorsRate,
        performanceLevel,
        wordCount,
        errorsCount,
        wcpm,
        retellRecall,
        retellScore,
        writtenComprehensionResultGroup,
        frustrationalAccuracy: isFrustrationalAccuracy,
    } = trcScore;
    const displayAccuracy = !isNil(accuracy) && !isFrustrationalAccuracy;
    const { msvsummary: msvSummary } = probeDetailResult;
    return (
        <SideBlock
            title="Status"
            content={
                <>
                    <strong>{measure}</strong>
                    <Accuracy
                        accuracy={accuracy}
                        selfCorrectionsRate={selfCorrectionsRate}
                        performanceLevel={performanceLevel}
                        errorsRate={errorsRate}
                        displayAccuracy={displayAccuracy}
                    />
                    <hr className="line" />
                    <div className="sidebar-content">
                        {!isFrustrationalAccuracy && (
                            <>
                                <strong>MSV</strong>
                                {showMsvGraph && <MsvGraph msvSummary={msvSummary} />}
                            </>
                        )}
                    </div>
                    <div className="legend">
                        {displayAccuracy && (
                            <>
                                <p>
                                    <span className="label">WD/Error:</span>
                                    {wordCount ? `${wordCount}/${errorsCount}` : NA}
                                </p>
                                <p>
                                    <span className="label">WCPM:</span>
                                    {isNil(wcpm) ? NA : wcpm}
                                </p>
                            </>
                        )}
                        <p>
                            <span className="label">
                                {getRetellTitle(retellRecall, atlas, bookType)}:
                            </span>
                            {retellScore
                                ? `${retellScore.actualResult}/${retellScore.maxResult}`
                                : NA}
                        </p>
                        <p>
                            <span className="label">Oral Comp:</span>
                            {getOralComprehensionValue(trcScore, probeDetailResult)}
                        </p>
                        <p>
                            <span className="label">Written Comp:</span>
                            {getWrittenComprehensionValue(writtenComprehensionResultGroup)}
                        </p>
                    </div>
                </>
            }
        />
    );
};

TrcStatusSection.defaultProps = {
    result: {},
    showMsvGraph: false,
};

TrcStatusSection.propTypes = {
    result: PropTypes.object,
    showMsvGraph: PropTypes.bool,
};

export default TrcStatusSection;
